/* eslint-disable no-unused-vars */
import {HTTP} from '../http-common';
import  soap from 'tinysoap';
import discovery from "../discovery";

export default {
    login(username, password, cbok, cberr) {        
        var url = discovery.wedrive_service_url + 'AuthenticationService?wsdl'
        var authRequest = {};
        var me = this;
        
        authRequest.login = username; 
        authRequest.password = window.$vue.CryptoJS.MD5(password).toString(); 
        authRequest.idApp = 9;
        authRequest.ip = '1.1.1.1';
        authRequest.close = true;
        authRequest.loginManager = window.$store.state.wedrive.isManager;
        authRequest.lang = window.$i18n.locale;

        soap.createClient(url, function(err, client) {
            if (err) { 
                cberr(window.$vue.$t('app.network-error'));
                return;
            }

            client.initSessionDrvApp(authRequest, function(err, result) {
                if (err) {
                    if (result && result.Body.Fault.detail.WemobException.errorCode) {
                        var error = '';

                        switch (result.Body.Fault.detail.WemobException.errorCode) {
                            case "0": error = window.$vue.$t('app.login-error-0'); break;
                            case "1": error = window.$vue.$t('app.login-error-1'); break;
                            case "7": error = window.$vue.$t('app.login-error-7'); break;
                            case "23": error = window.$vue.$t('app.login-error-23'); break;
                            default: error = window.$vue.$t('app.login-error-1'); break;
                        }

                        cberr(error);
                        return;
                    }

                    cberr(window.$vue.$t('app.network-error'));
                } else {
                    if (!result) {
                        cberr(window.$vue.$t('app.login-error-1'));
                        return;
                    }

                    cbok(result.return[0]);
                }
            });
        });
    },
    userInfo(cbok, cberr) {
		var url = discovery.wedrive_service_url + 'UserWebService?wsdl';
        var infoRequest = {};
        
        infoRequest.idSession = window.$store.state.wedrive.token;
        infoRequest.loginManager = window.$store.state.wedrive.isManager;
        infoRequest.lang = window.$i18n.locale;

        soap.createClient(url, function(err, client) {
            if (err) { 
                cberr(window.$vue.$t('app.network-error'));
                return;
            }

            client.selUserTrackingDrvApp(infoRequest, function(err, result) {
                if (err) {
                    cberr(window.$vue.$t('app.network-error'));
                } else {
                    if (!result) {
                        cberr(window.$vue.$t('app.session-expired'));
												//window.$router.push({ name: 'login', query: { sessionExpired: true } });
                        return;
                    }

                    cbok(result.user[0]);
                }
            });
        });
    },
    mobileGrid(cbok, cberr) {
        var url = discovery.wedrive_service_url + 'MobileWebService?wsdl';
        var gridRequest = {};
        
        gridRequest.idSession = window.$store.state.wedrive.token;
        gridRequest.idUser = window.$store.state.wedrive.user.idUser;
        gridRequest.idCompany = window.$store.state.wedrive.user.idCompany;
        gridRequest.lastUpdate = 0;
        gridRequest.idLanguage = 1;
        gridRequest.loginManager = window.$store.state.wedrive.isManager;
        gridRequest.lang = window.$i18n.locale;

        soap.createClient(url, function(err, client) {
            if (err) { 
                cberr(window.$vue.$t('app.network-error'));
                return;
            }

            client.selUserMobileGridDrvApp(gridRequest, function(err, result) {
                if (err) {
                    cberr(window.$vue.$t('app.network-error'));
                } else {
                    if (!result) {
                        window.$router.push({ name: 'login', query: { sessionExpired: true } });
                        return;
                    }
                    
                    cbok(result.mobile[0].mobileList);
                }
            });
        });
    },
    historicTemp(idFleet, idMobile, initTimestamp, endTimestamp, cbok, cberr) {
        var url = 'HistoricWebService_wsdl.xml';
        var tempRequest = {};
        
        tempRequest.idSession = window.$store.state.wedrive.token;
        tempRequest.idCompany = window.$store.state.wedrive.user.idCompany;
        tempRequest.idFleet = idFleet;
        tempRequest.idMobile = idMobile;
        tempRequest.initTimestamp = initTimestamp;
        tempRequest.endTimestamp = endTimestamp;
        tempRequest.lang = window.$i18n.locale;

        soap.createClient(url, function(err, client) {
            if (err) { 
                cberr(window.$vue.$t('app.network-error'));
                return;
            }

            client.selHistoricTempByDate(tempRequest, function(err, result) {
                if (err) {
                    cberr(window.$vue.$t('app.network-error'));
                } else {
                    if (!result) {
                        window.$router.push({ name: 'login', query: { sessionExpired: true } });
                        return;
                    }
                    
                    cbok(result.historicTempListByDate);
                }
            });
        });
    },
		historicTempByPeriod(idFleet, idMobile, initTimestamp, endTimestamp, period, cbok, cberr) {
        var url = 'HistoricWebService_wsdl.xml';
        var tempRequest = {};
        
        tempRequest.idSession = window.$store.state.wedrive.token;
        tempRequest.idCompany = window.$store.state.wedrive.user.idCompany;
        tempRequest.idFleet = idFleet;
        tempRequest.idMobile = idMobile;
        tempRequest.initTimestamp = initTimestamp;
        tempRequest.endTimestamp = endTimestamp;
        tempRequest.period = period;
        tempRequest.lang = window.$i18n.locale;

        soap.createClient(url, function(err, client) {
            if (err) { 
                cberr(window.$vue.$t('app.network-error'));
                return;
            }

            client.selHistoricTempByDatePeriod(tempRequest, function(err, result) {
                if (err) {
                    cberr(window.$vue.$t('app.network-error'));
                } else {
                    if (!result) {
                        window.$router.push({ name: 'login', query: { sessionExpired: true } });
                        return;
                    }
                    
                    cbok(result.historicTempListByDate);
                }
            });
        });
    },
		getTemperaturesReportPDF(idFleet, idMobile, initTimestamp, endTimestamp, period, cbok, cberr) {
            var url = 'https://apps.wemob.es/WeCoDrive/server/temperatures/getTemperaturesReport.jsp?';
				url += `items=${idFleet + "," + idMobile}&`;
				url += `iTs=${initTimestamp}&`;
				url += `eTs=${endTimestamp}&`;
				url += 'type=0&';
				url += 'grp=1&';
				url += `idu=${window.$store.state.wedrive.user.idUser}&`;
				url += `per=${period}&`;
				url += `ids=${window.$store.state.wedrive.token}&`;
				url += `lang=${window.$i18n.locale}&`;
				url += 'grco=';

        HTTP.get(url,
            {
                responseType: 'blob'
            })
            .then((response) => {
                cbok(response.data);
            }).catch(function (error) {
                cberr(error);
            });
		}
}